import { CreateIconArguments } from '##/icons/Icon/helpers';

import IconHorizonMultipleSizeS from './IconHorizonMultiple_size_s';

const props: CreateIconArguments = {
  l: IconHorizonMultipleSizeS,
  m: IconHorizonMultipleSizeS,
  s: IconHorizonMultipleSizeS,
  xs: IconHorizonMultipleSizeS,
  name: 'IconHorizonMultiple',
  renderType: { l: 'use', m: 'use', s: 'use', xs: 'use' },
  color: 'multiple',
};

export default props;
